import React, { useEffect } from 'react';
import UI from '../../constants/ui';
import STORAGE_KEY from '../../constants/storageKey';

function Error() {
  useEffect(() => {
    const redirectUrl = window.location.pathname;
    sessionStorage.setItem(STORAGE_KEY.REDIRECTION_URL, redirectUrl);
  }, []);

  return (
    <div className="m-auto text-center">
      <h1>{UI.PAGE_NOT_FOUND}</h1>
    </div>
  );
}

export default Error;
